export const sanitizeQuery = (query) => query?.replace(/[^\p{L}\p{N}\s,&.\-']+/gu, '') || '';
